/** Заготовки текста интерфейса из исходного шаблона BotPhoto; нажатие только заполняет черновик. */
export const photoPromptPresets = [
  ['Портрет в студии','Студийный портрет на однотонном фоне, мягкий рассеянный свет'],
  ['Город ночью','Ночная улица большого города, огни витрин, мокрый асфальт'],
  ['На природе','Летний лес, солнечные лучи сквозь листву'],
  ['В кафе','Уютное кафе у окна, утренний свет, чашка кофе'],
  ['У моря','Берег моря на закате, лёгкий ветер'],
] as const;
